import { Token } from '@piconetworks/login'
import PropTypes from 'prop-types'
import withInjection from '@piconetworks/with-injection'

import WizardRedux from 'common/pkgs/WizardRedux'
import Account from 'common/modules/account'
import Auth from 'common/modules/auth'
import Loader from 'common/modules/loader'
import Zoid from 'common/modules/zoid'
import { Link } from '@piconetworks/router-adapter'

const onLoginComponent = ({ submitForm }) => (
    <WizardRedux.Step
        validate={() => {
            const errors = {}

            return errors
        }}
        onSubmit={async () => ({
            submitWizard: true,
        })}
        render={({
            form,
        }) => {
            if (submitForm) {
                form.submit()
            }

            return null
        }}
    />
)

onLoginComponent.defaultProps = {
    submitForm: false,
}

onLoginComponent.propTypes = {
    submitForm: PropTypes.bool,
}

const mapStateToProps = (state, props) => ({
    ...props,
    isAuthed: state.auth.isAuthed,
    linkColor: Loader.selectors.linkColor(state),
    tryAgainHref: '/login',
    tryAgainAs: '/login',
    onLoginComponent,
    emailLinkExpiration: Zoid.selectors.isEmailLinkExpired(state),
    Link,
})

const mapDispatchToProps = (dispatch) => ({
    dispatch,
})

const mergeProps = (stateProps, dispatchProps, ownProps) => {
    const { dispatch } = dispatchProps
    const {
        router,
        short_code,
    } = stateProps

    return {
        ...ownProps,
        ...stateProps,
        ...dispatchProps,
        doTokenLoken: ({
            accessToken,
            refreshToken,
        }) => {
            dispatch(Auth.creators.tokenLogin({
                accessToken,
                refreshToken,
            }))
        },
        hasPasswordResetAuth: () => {
            dispatch(Account.creators.hasPasswordResetAuth())

            router.replace({
                pathname: '/account/edit-password',
                query: {
                    ...(short_code && { short_code }),
                },
            }, {
                pathname: '/account/edit-password',
                query: {
                    ...(short_code && { short_code }),
                },
            })
        },
    }
}

const InjectedToken = withInjection(Token, {
    mapStateToProps,
    mapDispatchToProps,
    mergeProps,
})

export default InjectedToken
